import { type QuestionKey, SectionKey } from "@/types/questions";
import { useSupplementsStore } from "@/stores/supplements";
import { RouteKeyToPathMapper } from "@/router/routes";
import router from "@/router/index";
import { sectionToNumberStep } from "@/utils/constants";
import { useCrm } from "@/composables/useCrm";
import { useQuestionsStore } from "@/stores/questions";
import { sendFormulaGuardEvents } from "@/utils/analytics";
import { updateDataLayerGuard } from "@/utils/dataLayer";
import { useProductsStore } from "@/stores/products";
import { useABVersionsStore } from "@/stores/abVersions";

export const createQuestionRoute = (key: QuestionKey, sKey: SectionKey) => {
  if (router.hasRoute(key)) return { name: key };

  router.addRoute("main", {
    path: `${RouteKeyToPathMapper[key]}`,
    component: () => import("@/components/QuestionActive.vue"),
    name: key,
    meta: { qKey: key, sKey },
    beforeEnter: updateDataLayerGuard,
  });
  return { name: key };
};

export const createSectionRoute = (key: SectionKey) => {
  if (router.hasRoute(key)) return { name: key };

  router.addRoute("main", {
    path: `${RouteKeyToPathMapper[key]}`,
    component: () => import("@/views/SectionComp.vue"),
    name: key,
    props: { sectionNr: sectionToNumberStep[key] },
    beforeEnter: updateDataLayerGuard,
  });
  return { name: key };
};

export const loadContactFromCrm = async (to: any) => {
  const { shouldLoadContact, loadDataFromContact } = useCrm();
  if (!shouldLoadContact(to)) return true;

  const contactLoadedWithSuccess = await loadDataFromContact(to);
  const formulaExists = sendFormulaGuardEvents();

  const redirectUrl =
    import.meta.env.VITE_NODE_ENV === "production"
      ? import.meta.env.VITE_LP_URL_PROD
      : import.meta.env.VITE_LP_URL_STAGING;

  if (contactLoadedWithSuccess && formulaExists) return true;
  else {
    window.location.replace(redirectUrl);
  }

  return true as never;
};

export const checkForFormulaUuid = async (to: any) => {
  const supplementsStore = useSupplementsStore();
  if (!supplementsStore.formulaDraftUuid) return { name: SectionKey.INTRO, query: to.query };
  return true;
};

export const saveQuestionnaireToLS = () => {
  const questStore = useQuestionsStore();
  questStore.saveDataToStorage();
};

export const checkEligibility = async () => {
  const productsStore = useProductsStore();
  productsStore.fetchCheckEligibility();
  return true;
};

export const productionGuard = (to: any, from: any) => {
  const env = import.meta.env.VITE_NODE_ENV;
  if (env === "production") return { name: from.name || SectionKey.INTRO, query: to.query };
};

export const shouldGoToShopifyPPGuard = () => {
  const abVersionsStore = useABVersionsStore();

  const redirectLink = abVersionsStore.constructShopifyPPLink();
  if (redirectLink) {
    window.location.assign(redirectLink);
    return false;
  } else {
    return true;
  }
};
